import { useEffect, useState } from 'react';
import './ToggleButton.css';

export default function ToggleSwitch({onToggle, defaultValue=''}) {
  const [isActive, setIsActive] = useState(defaultValue);
  
  const toggleSwitch = () => {
    const newState = !isActive;
    setIsActive(newState);
    onToggle(newState);
  };
  

  useEffect(() =>{
    setIsActive(defaultValue)
  },[defaultValue])

  return (
    <div className="toggle-container">
      <button 
        onClick={toggleSwitch}
        className="toggle-button-perm"
        aria-pressed={isActive}
        role="switch"
      >
        <div className="toggle-switch">
          {isActive ? (
            // Active SVG (green)
            <svg className='switch-icon' xmlns="http://www.w3.org/2000/svg" width="50" height="26" viewBox="0 0 50 26" fill="none">
              <rect width="50" height="26" rx="13" fill="#D9D9D9"/>
              <circle cx="37" cy="13" r="12" fill="#148F00"/>
            </svg>
          ) : (
            <svg className='switch-icon' xmlns="http://www.w3.org/2000/svg" width="50" height="26" viewBox="0 0 50 26" fill="none">
              <rect width="50" height="26" rx="13" fill="#D9D9D9"/>
              <circle cx="13" cy="13" r="12" fill="#535353"/>
            </svg>
          )}
        </div>
      </button>
    </div>
  );
}